import type { TextMatchTransformer } from "@lexical/markdown"

import { $createObjectLinkNode, $isObjectLinkNode, ObjectLinkNode } from "../nodes/object-link"

// Pattern: {{objlink:base64-encoded-json}}
const OBJECT_LINK_REGEX = /\{\{objlink:([A-Za-z0-9+/=]+)\}\}/

export const ObjectLinkTransformer: TextMatchTransformer = {
  type: "text-match",
  dependencies: [ObjectLinkNode],
  regExp: OBJECT_LINK_REGEX,
  importRegExp: OBJECT_LINK_REGEX,
  replace: (textNode, match) => {
    try {
      const encoded = match[1]
      const jsonStr = decodeURIComponent(escape(atob(encoded)))
      const { type, id, label } = JSON.parse(jsonStr)
      const objectLinkNode = $createObjectLinkNode(type, id, label)
      textNode.replace(objectLinkNode)
    } catch {
      return
    }
  },
  trigger: "}",
  export: (node) => {
    if (!$isObjectLinkNode(node)) {
      return null
    }
    const jsonStr = JSON.stringify({ type: node.__objectType, id: node.__objectId, label: node.__label })
    const encoded = btoa(unescape(encodeURIComponent(jsonStr)))
    return `{{objlink:${encoded}}}`
  },
}
